import { createSlice } from '@reduxjs/toolkit';

import { fetchUserTips, markTipsPaid, setTipStatus } from './thunk';

const STATUS_UNPAID = 0;
const STATUS_PAID = 1;

export const initialState = {
  items: [],
  loading: false,
  updating: false,
  error: null,
};

const AdminUserTipsSlice = createSlice({
  name: 'AdminUserTips',
  initialState,
  reducers: {
    clearAdminUserTips: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserTips.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserTips.fulfilled, (state, action) => {
        state.loading = false;
        state.items = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchUserTips.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markTipsPaid.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(markTipsPaid.fulfilled, (state, action) => {
        state.updating = false;
        // Backend rozlicza wskazane id, a przy ich braku wszystkie nierozliczone —
        // odwzorowujemy to lokalnie, żeby nie pobierać listy jeszcze raz.
        const ids = action.meta.arg?.ids ?? null;
        state.items = state.items.map((tip) =>
          tip.status === STATUS_UNPAID && (ids === null || ids.includes(tip.id))
            ? { ...tip, status: STATUS_PAID }
            : tip
        );
      })
      .addCase(markTipsPaid.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      })

      .addCase(setTipStatus.pending, (state) => {
        state.updating = true;
        state.error = null;
      })
      .addCase(setTipStatus.fulfilled, (state, action) => {
        state.updating = false;
        const updated = action.payload;
        state.items = state.items.map((tip) =>
          tip.id === updated?.id ? { ...tip, ...updated } : tip
        );
      })
      .addCase(setTipStatus.rejected, (state, action) => {
        state.updating = false;
        state.error = action.payload;
      });
  },
});

export const { clearAdminUserTips } = AdminUserTipsSlice.actions;

export const selectAdminUserTips = (state) => state.AdminUserTips.items;
export const selectAdminUserTipsLoading = (state) => state.AdminUserTips.loading;
export const selectAdminUserTipsUpdating = (state) => state.AdminUserTips.updating;
export const selectAdminUserTipsError = (state) => state.AdminUserTips.error;

export default AdminUserTipsSlice.reducer;
